import React from "react"
import PropTypes from "prop-types"
import { Typography } from "antd"

import {
  getCurrencyValue,
  getInvestmentTierAmount,
  getInvestmentTierCurrency,
} from "./helpers/getInvestedAmount"
import { InvestmentShape } from "../shapes"


const TableAmountColumn = ({
  sourceInvestmentId = undefined,
  tierId,
  isIncluded,
  investment,
  customAmountsMap,
  sourceInvestments,
}) => {
  const getSourceInvestment = investmentId =>
    sourceInvestments.find(({ id }) => id === investmentId)

  if (!isIncluded) {
    return (
      <Typography.Text type="secondary">
        <span style={{ whiteSpace: "nowrap" }}>
          {getInvestmentTierCurrency(tierId, investment)}
        </span>
      </Typography.Text>
    )
  }

  const investmentCustomAmounts = customAmountsMap[investment.id]
  const hasCustomAmounts = !!investmentCustomAmounts

  if (hasCustomAmounts) {
    const customAmount = investmentCustomAmounts[tierId]

    if (customAmount) {
      return (
        <Typography.Text strong style={{ color: "#faad14" }}>
          <span style={{ whiteSpace: "nowrap" }}>
            {getCurrencyValue(customAmount)}
          </span>
        </Typography.Text>
      )
    }
  }

  const wrapperStyle = hasCustomAmounts
    ? { whiteSpace: "nowrap", textDecoration: "line-through", opacity: 0.5 }
    : { whiteSpace: "nowrap" }

  if (!sourceInvestmentId) {
    return (
      <span style={wrapperStyle}>
        {getInvestmentTierCurrency(tierId, investment)}
      </span>
    )
  }

  const sourceInvestment = getSourceInvestment(sourceInvestmentId)

  const amount = getInvestmentTierAmount(tierId, investment) || 0
  const sourceAmount = getInvestmentTierAmount(tierId, sourceInvestment) || 0

  const newAmount = amount + sourceAmount
  const currencyValue = getCurrencyValue(newAmount)

  if (newAmount) {
    const isTargetAmountChanged =
      !!amount &&
      !!sourceAmount

    return (
      <span style={wrapperStyle}>
        {
          isTargetAmountChanged
            ? <Typography.Text strong style={{ color: "#52c41a" }}>{currencyValue}</Typography.Text>
            : currencyValue
        }
      </span>
    )
  }

  return null
}

TableAmountColumn.propTypes = {
  tierId: PropTypes.string.isRequired,
  isIncluded: PropTypes.bool.isRequired,
  investment: InvestmentShape.isRequired,
  customAmountsMap: PropTypes.shape().isRequired,
  sourceInvestmentId: PropTypes.string,
  sourceInvestments: PropTypes.arrayOf(InvestmentShape).isRequired,
}

export default TableAmountColumn
